import React from 'react';
import { useTranslation } from 'react-i18next';

import { useGlobalContext } from 'contexts/global-context';
import useGameSelection from 'hooks/useGameSelection';
import GridGames, { MainItemPosition } from 'components/grid-games';
import { getChunks } from 'utils';
import { TGame, ABTest } from 'types';
import './styles.scss';

interface IPokiLookALikeGames {
  games: TGame[];
}

const PokiLookALikeGames: React.FC<IPokiLookALikeGames> = ({ games }) => {
  const { t } = useTranslation();
  const { abTestId } = useGlobalContext();
  const positions = [MainItemPosition.bottomRight, MainItemPosition.bottomLeft];
  const splittedGames = getChunks(
    abTestId === ABTest.switchMainVideo ? games.slice(0, 12) : games,
    abTestId === ABTest.switchMainVideo ? 6 : 7
  );

  const { selectedGame, select, pause } = useGameSelection(games, abTestId === ABTest.autoShowGetBtnOnGame);

  const handleGameClick = (game: TGame) => {
    select(game);

    if (abTestId === ABTest.autoShowGetBtnOnGame) {
      pause(true);
    }
  };

  return (
    <div className="grid-look-a-like-games-container">
      <p className="p-side">{t('moreGamesYouLike')}</p>
      {splittedGames.map((splittedGamePack, index) => (
        <GridGames
          key={index}
          className="p-side"
          mainItemPosition={positions[index % 2]}
          games={splittedGamePack}
          selectedGame={selectedGame}
          onGameClick={handleGameClick}
        />
      ))}
    </div>
  );
};

export default PokiLookALikeGames;
